(() => {
  const initJassScrollProgress = () => {
    const progress = document.getElementById('JassScrollProgress');

    if (!progress || progress.dataset.initialized === 'true') return;

    const fill = progress.querySelector('.jass-scroll-progress__fill');
    const pearl = progress.querySelector('.jass-scroll-progress__pearl');

    if (!fill || !pearl) return;

    progress.dataset.initialized = 'true';

    let ticking = false;

    const updateProgress = () => {
      const documentElement = document.documentElement;

      const scrollTop =
        window.scrollY ||
        documentElement.scrollTop ||
        document.body.scrollTop ||
        0;

      const scrollableHeight =
        documentElement.scrollHeight - window.innerHeight;

      const ratio =
        scrollableHeight > 0
          ? Math.min(Math.max(scrollTop / scrollableHeight, 0), 1)
          : 0;

      const percentage = ratio * 100;

      fill.style.transform = `scaleX(${ratio})`;
      pearl.style.left = `${percentage}%`;

      progress.classList.toggle('is-visible', scrollTop > 8);
      progress.classList.toggle('is-complete', ratio >= 0.995);

      ticking = false;
    };

    const requestUpdate = () => {
      if (ticking) return;

      ticking = true;
      window.requestAnimationFrame(updateProgress);
    };

    window.addEventListener('scroll', requestUpdate, {
      passive: true
    });

    window.addEventListener('resize', requestUpdate);

    document.addEventListener('shopify:section:load', requestUpdate);
    document.addEventListener('shopify:section:unload', requestUpdate);

    requestUpdate();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initJassScrollProgress, {
      once: true
    });
  } else {
    initJassScrollProgress();
  }

  document.addEventListener('shopify:section:load', initJassScrollProgress);
})();

(() => {
  const initJassReveals = () => {
    const elements = document.querySelectorAll(
      '.jass-reveal:not([data-jass-reveal-ready])'
    );

    if (!elements.length) return;

    const reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (reducedMotion || !('IntersectionObserver' in window)) {
      elements.forEach((element) => {
        element.dataset.jassRevealReady = 'true';
        element.classList.add('is-visible');
      });

      return;
    }

    const observer = new IntersectionObserver(
      (entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          currentObserver.unobserve(entry.target);
        });
      },
      {
        root: null,
        threshold: 0.12,
        rootMargin: '0px 0px -8% 0px'
      }
    );

    elements.forEach((element) => {
      element.dataset.jassRevealReady = 'true';
      observer.observe(element);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initJassReveals, {
      once: true
    });
  } else {
    initJassReveals();
  }

  document.addEventListener('shopify:section:load', initJassReveals);
})();

(() => {
  const initJassNavbarScroll = () => {
    if (document.body.dataset.jassNavbarReady === 'true') return;

    document.body.dataset.jassNavbarReady = 'true';

    let ticking = false;

    const updateNavbar = () => {
      document.body.classList.toggle('jass-scrolled', window.scrollY > 24);
      ticking = false;
    };

    const requestNavbarUpdate = () => {
      if (ticking) return;

      ticking = true;
      window.requestAnimationFrame(updateNavbar);
    };

    window.addEventListener('scroll', requestNavbarUpdate, {
      passive: true
    });

    updateNavbar();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initJassNavbarScroll, {
      once: true
    });
  } else {
    initJassNavbarScroll();
  }
})();

(() => {
  const enter = () => {
    document.body.classList.add("jass-page-entering");

    requestAnimationFrame(() => {
      document.body.classList.add("jass-page-ready");
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", enter, { once: true });
  } else {
    enter();
  }

  document.addEventListener("click", (event) => {
    const link = event.target.closest("a");

    if (!link) return;

    if (
      link.target === "_blank" ||
      link.hasAttribute("download") ||
      link.origin !== location.origin ||
      link.href.startsWith("mailto:") ||
      link.href.startsWith("tel:") ||
      link.href.includes("#")
    ) {
      return;
    }

    document.body.classList.add("jass-page-leaving");
  });
})();